import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { PhoneUnitDeprecatedService, PhoneUnitService, RecordEntryService, RecordService } from '@contact/upgrade';

import Conference from './conference/conference.module.ajs';
import Outcall from './outcall/unit-outgoing-call.module.ajs';
import { default as recordDeprecatedServiceName, RecordDeprecatedService } from './record-deprecated.service';
import ScriptArgument from './script-argument/script-argument.module.ajs';
import ScriptRedirection from './script-redirection/script-redirection.module.ajs';

export default module('contact.agent.core.phone', [Conference, Outcall, ScriptArgument, ScriptRedirection])
  // instanciate services module
  .run([recordDeprecatedServiceName, () => {}])
  .service(recordDeprecatedServiceName, RecordDeprecatedService)
  .factory('phoneUnitDeprecatedService', downgradeInjectable(PhoneUnitDeprecatedService as any))
  .factory('phoneUnitService', downgradeInjectable(PhoneUnitService as any))
  .factory('recordService', downgradeInjectable(RecordService as any))
  .factory('recordEntryService', downgradeInjectable(RecordEntryService as any)).name;
